import React from "react";
import { LOGO_MARK, LOGO_FULL } from "@/lib/data";
import { Link } from "react-router-dom";

export const Logo = ({ variant = "mark", className = "", linkTo = "/", size = 44 }) => {
  const src = variant === "full" ? LOGO_FULL : LOGO_MARK;
  const inner = (
    <img
      src={src}
      alt="WelkomBiz Photography"
      style={{
        height: size,
        width: "auto",
        background: "transparent",
        objectFit: "contain",
      }}
      className={`block select-none ${className}`}
      draggable={false}
    />
  );
  if (!linkTo) return inner;
  return (
    <Link to={linkTo} data-testid="brand-logo-link" className="inline-flex items-center">
      {inner}
    </Link>
  );
};

export default Logo;
